export function isValidFullName(value: string): boolean {
  return (
    value.trim().split(/\s+/).filter((part) => part.length >= 2).length >= 2
  );
}
